// map typography tokens accordenly
export default _ref => {
  let {
    topTextFontSize,
    fontColor,
    topTextLineHeight,
    currencySymbolFontSize,
    currencySymbolLineHeight,
    currencySymbolFontWeight,
    currencySymbolPaddingTop,
    amountFontSize,
    amountLineHeight,
    amountLetterSpacing,
    amountFontWeight,
    centsFontSize,
    centsLineHeight,
    centsPaddingTop,
    rateFontSize,
    rateLineHeight,
    bottomTextFontSize,
    bottomTextLineHeight,
    rateFontWeight,
    centsFontWeight
  } = _ref;
  return {
    topText: {
      fontSize: topTextFontSize,
      lineHeight: topTextLineHeight
    },
    dollarSign: {
      fontSize: currencySymbolFontSize,
      lineHeight: currencySymbolLineHeight,
      fontWeight: currencySymbolFontWeight,
      paddingTop: currencySymbolPaddingTop
    },
    amount: {
      color: fontColor,
      fontSize: amountFontSize,
      lineHeight: amountLineHeight,
      letterSpacing: amountLetterSpacing,
      fontWeight: amountFontWeight
    },
    cents: {
      fontSize: centsFontSize,
      lineHeight: centsLineHeight,
      fontWeight: centsFontWeight,
      paddingTop: centsPaddingTop
    },
    rate: {
      fontSize: rateFontSize,
      lineHeight: rateLineHeight,
      fontWeight: rateFontWeight
    },
    bottomText: {
      fontSize: bottomTextFontSize,
      lineHeight: bottomTextLineHeight
    }
  };
};